/* SBO v3 routine sets: keeps a set's "Add set" button, line prices and total
   in step with its variant pickers (a shade, a strength). Adding to the cart
   itself is the shared [data-sbo3-add-cart] handler in
   assets/sbo-v3-cart-actions.js. Loaded by sections/sbo-v3-sets.liquid.

   Prices arrive in cents from Liquid. Totals are formatted with the store's
   own money format: the section renders a known amount (12,345.00) through
   the `money` filter, and the total is written into that same template, so
   the currency symbol, separators and suffix match the prices around it. */

(() => {
  function formatMoney(cents, template) {
    const match = template && template.match(/12(\D?)345(?:(\D)00)?/);
    if (!match) {
      return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    const [sample, thousands, decimal] = match;
    const whole = decimal ? Math.floor(cents / 100) : Math.round(cents / 100);
    const grouped = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thousands || '');
    const amount = decimal ? `${grouped}${decimal}${String(cents % 100).padStart(2, '0')}` : grouped;
    return template.replace(sample, amount);
  }

  function update(set, template) {
    const lines = Array.from(set.querySelectorAll('[data-sbo3-set-line]'));
    let total = 0;
    let compare = 0;

    lines.forEach(line => {
      const picker = line.querySelector('[data-sbo3-set-variant]');
      const option = picker && picker.selectedOptions[0];
      if (option) {
        line.dataset.variantId = option.value;
        line.dataset.price = option.dataset.price;
        line.dataset.compare = option.dataset.compare;
        const price = line.querySelector('[data-sbo3-set-price]');
        if (price) price.textContent = option.dataset.priceLabel;
      }
      total += Number(line.dataset.price) || 0;
      compare += Number(line.dataset.compare) || 0;
    });

    const button = set.querySelector('[data-sbo3-add-cart]');
    if (button) button.dataset.variantIds = lines.map(line => line.dataset.variantId).join(',');

    const totalNode = set.querySelector('[data-sbo3-set-total]');
    if (totalNode) totalNode.textContent = formatMoney(total, template);

    const compareNode = set.querySelector('[data-sbo3-set-compare]');
    if (compareNode) {
      compareNode.hidden = !(compare > total);
      const value = compareNode.querySelector('[data-sbo3-set-compare-value]');
      if (value) value.textContent = formatMoney(compare, template);
    }

    const ship = set.querySelector('[data-sbo3-set-ship]');
    if (ship) ship.hidden = total < Number(ship.dataset.threshold);
  }

  function init(root) {
    root.querySelectorAll('.sbov3sets').forEach(section => {
      if (section.dataset.sbo3SetsReady) return;
      section.dataset.sbo3SetsReady = 'true';
      const template = section.dataset.sbo3MoneyTemplate;
      section.addEventListener('change', event => {
        if (!event.target.matches('[data-sbo3-set-variant]')) return;
        const set = event.target.closest('[data-sbo3-set]');
        if (set) update(set, template);
      });
      /* The button adds what the pickers show at the moment it is pressed.
         This listener runs before the shared one on document, which reads
         the button's variant ids. */
      section.addEventListener('click', event => {
        const set = event.target.closest('[data-sbo3-add-cart]') && event.target.closest('[data-sbo3-set]');
        if (set) update(set, template);
      });
      syncShown(section);
    });
  }

  /* After Back, the browser puts a changed picker back as it was. It can do
     that after this script has run (then no change event fires), so the total
     and "Ships free" are brought in line again once the page is shown. */
  function syncShown(section) {
    section.querySelectorAll('[data-sbo3-set]').forEach(set => {
      if (set.querySelector('[data-sbo3-set-variant]')) update(set, section.dataset.sbo3MoneyTemplate);
    });
  }

  window.addEventListener('pageshow', () => document.querySelectorAll('.sbov3sets').forEach(syncShown));

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
